








import Vue from 'vue';
import Component from 'vue-class-component';

const WordFade = () => import('../../common/vue/WordFade.vue');

const HeadlineProps = Vue.extend({
  props: {
    headline: String,
    headlineTag: {
      type: String,
      default: 'h2',
    },
    alignment: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'right', 'center'].includes(val),
    },
    color: {
      type: String,
      default: 'white',
      validator: (val) => ['white', 'black'].includes(val),
    },
    size: {
      type: String,
      default: 'xxl',
      validator: (val) => ['xxl', 'xl', '90', 'l', 'm', 's', 'xs', 'xxs', 'inherit'].includes(val),
    },
    delay: Number,
  },
});

@Component({
  components: {
    WordFade,
  },
})
export default class Headline extends HeadlineProps {
  get rootClasses () {
    return {
      'brandhub-headline--color-black': this.color === 'black',
      'brandhub-headline--color-white': this.color === 'white',
      'brandhub-headline--color-theme': this.color === 'theme',
      'brandhub-headline--alignment-center': this.alignment === 'center',
      'brandhub-headline--alignment-left': this.alignment === 'left',
      'brandhub-headline--alignment-right': this.alignment === 'right',
    };
  }

  get headlineModifierClasses () {
    return {
      'brandhub-headline__headline--size-xxl': this.size === 'xxl',
      'brandhub-headline__headline--size-xl': this.size === 'xl',
      'brandhub-headline__headline--size-90': this.size === '90',
      'brandhub-headline__headline--size-l': this.size === 'l',
      'brandhub-headline__headline--size-m': this.size === 'm',
      'brandhub-headline__headline--size-s': this.size === 's',
      'brandhub-headline__headline--size-xs': this.size === 'xs',
      'brandhub-headline__headline--size-xxs': this.size === 'xxs',
      'brandhub-headline__headline--size-inherit': this.size === 'inherit',
    };
  }
}
